import AuthorizedDeviceEnrollmentPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AuthorizedDeviceEnrollmentPage";
import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import Classes from "model";

export default function CaptureMabiFaceIDClosePopup(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "mobile", "name" ], "George's IPhone")
        .update([ "mobile", "userID" ], "georgew")
        .update([ "mobile", "password" ], "12345678")
        .update([ "mobile", "isEnrolled" ], true)
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "confirmationBanner", "isActive" ], false)
        .submit();

    return <AuthorizedDeviceEnrollmentPage data={ data } ui={ ui } />
}